import ApiRequestService from "services/ApiRequestService";

export const EmployeeReviewsService = {
    getOptions() {
        return ApiRequestService.get("employee", "Options/EmployeeReviews");
    },
    getStats(locationIds) {
        return ApiRequestService.post("employee", "EmployeeReviews/Stats/Search", { locationIds });
    },
    searchPendingReviews(searchRequest) {
        return ApiRequestService.post("employee", "EmployeeReviews/Pending/Search", searchRequest);
    },
    searchCompletedReviews(searchRequest) {
        return ApiRequestService.post("employee", "EmployeeReviews/Completed/Search", searchRequest);
    },
    searchEmployeeReviews(employeeId, searchRequest) {
        return ApiRequestService.post("employee", `EmployeeReviews/Employee/${employeeId}/Search`, searchRequest);
    },
    getCompletedReview(reviewId) {
        return ApiRequestService.get("employee", `EmployeeReviews/${reviewId}`);
    },
    getPendingReview(pendingReviewId) {
        return ApiRequestService.get("employee", `EmployeeReviews/Pending/${pendingReviewId}`);
    },
    getAvailableReviewTypes(employeeId) {
        return ApiRequestService.get("employee", `EmployeeReviews/Employee/${employeeId}/ReviewTypes`);
    },
    getReviewForCompletion(employeeId, reviewTypeId) {
        return ApiRequestService.get("employee", `EmployeeReviews/Employee/${employeeId}/ReviewTypes/${reviewTypeId}/ForCompletion`);
    },
    completeReview(pendingReviewId, request) {
        return ApiRequestService.post("employee", `EmployeeReviews/Pending/${pendingReviewId}/Complete`, request);
    },
    completeAdHocReview(employeeId, reviewTypeId, request) {
        return ApiRequestService.post("employee", `EmployeeReviews/Employee/${employeeId}/ReviewTypes/${reviewTypeId}/Complete`, request);
    },
    // Rejects with the response itself, so the caller can show the API's own 400 reason.
    updateCompletedReview(reviewId, request) {
        return ApiRequestService.put("employee", `EmployeeReviews/${reviewId}`, request);
    },
    // The emailed sign-off link's three values are the only credential this endpoint accepts,
    // so it is anonymous: it returns the completed review only when all three match one row.
    getReviewSignOff(employeeId, reviewId, token) {
        return ApiRequestService.get("employee", `EmployeeReviews/Signoff?employeeId=${encodeURIComponent(employeeId)}&reviewId=${encodeURIComponent(reviewId)}&token=${encodeURIComponent(token)}`);
    },
    // Built against PBI 171413's specified contract; the endpoint is not yet implemented,
    // so the route and body shape are unverified against a live implementation.
    saveReviewSignOff(request) {
        return ApiRequestService.patch("employee", "EmployeeReviews/Signoff/Email", request);
    },
    // No errorMessage is passed so the rejection carries the response itself, letting the caller
    // tell the API's own 400 reason apart from an unexpected failure.
    sendReviewSignOffEmail(reviewId, signOffEmailAddress) {
        return ApiRequestService.post("employee", `EmployeeReviews/${reviewId}/Signoff/Email`, { signOffEmailAddress });
    },
    // Queues the review's PDF and resolves the report queue id the reporting service is polled with.
    generateCompletedReviewReport(reviewId) {
        return ApiRequestService.post("employee", "EmployeeReviewReports/CompletedReview", { reviewId });
    }
};
